// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__MR2Bu","icon":"EnquiryForm_icon__1OZcf","heading":"EnquiryForm_heading__1YFxw","field":"EnquiryForm_field__2WW_C","error":"EnquiryForm_error__11ySB"};